import { useCallback, useRef, useState } from "react";
import { useNotify } from "react-admin";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import LoadingActionButton from "server/components/LoadingActionButton";
import { importResults } from "./utils";
import ImportErrorsDialog from "./ImportErrorsDialog";

const UpdateExamResultsButton = ({ exam, isFinished }) => {
  const notify = useNotify();
  const inputRef = useRef(null);

  const [errors, setErrors] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const changeHandler = useCallback(
    async event => {
      setLoading(true);

      const result = await importResults(event, exam.campaignExamId, "PATCH", notify);

      if (result?.length > 0) {
        setErrors(result);
        setOpen(true);
      }

      inputRef.current.value = null;
      setLoading(false);
    },
    [notify, exam.campaignExamId],
  );

  if (!exam) {
    return null;
  }

  return (
    <>
      <input
        type="file"
        accept=".xlsx"
        style={{ display: "none" }}
        ref={inputRef}
        onChange={changeHandler}
      />
      <LoadingActionButton
        label="Редактирай оценки"
        icon={<SaveAsIcon />}
        onClick={() => inputRef.current.click()}
        disabled={exam.examFinalized || isFinished}
        loading={loading}
      />
      <ImportErrorsDialog
        open={open}
        onClose={() => setOpen(false)}
        errors={errors}
      />
    </>
  );
};

export default UpdateExamResultsButton;
